import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config-service/config.service';
import { LoginService, User } from '../login-service/login.service';
import { MarketPlaceQuoteRequestService } from 'src/app/services/market-place-quote-request-service/market-place-quote-request.service';
import { RailCar } from 'src/app/routes/search-cars-component/car-filter.helper';
import { Router } from '@angular/router';
import { filterSelectionState } from '../../routes/search-cars-component/search-cars.helper.consts';
import { OptionModel } from 'src/app/models/railcar-display-options.model';

@Injectable({
  providedIn: 'root',
})
export class draftQuoteRequest {
  public config: any = null;
  arrayFile: any;
  clientData: User = {} as User;
  selectedStcc: any;
  selectedCars: RailCar[] = [];
  selectedCarType: any;
  CarAttrDetails: any;
  private selectedCarTypeAttributesSource$ = new BehaviorSubject<OptionModel[]>(
    []
  );
  selectedCarTypeAttributes =
    this.selectedCarTypeAttributesSource$.asObservable();
  constructor(
    private configService: ConfigService,
    private loginService: LoginService,
    private http: HttpClient,
    private quoteRequestService: MarketPlaceQuoteRequestService,
    private router: Router
  ) {
    const strConfig = localStorage.getItem('config-service');
    if (strConfig !== null) this.config = JSON.parse(strConfig);
    else {
      this.configService._config_$.subscribe((x) => {
        this.config = x;
      });
    }
    this.loginService.user$.subscribe((res) => {
      this.clientData = res;
    });
  }

  getDraftQuote(): Observable<any> {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    return this.http.post(
      this.config.draftQuoteDetails,
      {},
      {
        headers,
      }
    );
  }

  deleteDraftQuation() {
    this.deleteQuote().subscribe(
      () => {},
      (error) => {}
    );
  }

  deleteQuote(): Observable<any> {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    return this.http.post(
      this.config.deleteQuoteDetails,
      {},
      {
        headers,
      }
    );
  }

  saveDraftQuation(reqeustStep: string) {
    let final: any = '';
    this.quoteRequestService.quoteRequest$.subscribe((response) => {
      final = response;
    });
    const stcc = this.quoteRequestService.getDefaultStcc()?.description_stcc;
    this.selectedStcc =
      stcc === 'Other' ? this.quoteRequestService.getProductName() : stcc;
    const { selectedCars } = this.quoteRequestService.getSelectedCarList();
    this.selectedCarType = this.quoteRequestService.getSelectedCarType();
    const obj = {
      'user-profile': {
        date: new Date(),
        userid: this.clientData['contact-info'].userid,
      },
      'lease-details': final['lease-details'],
      'mechanical-options': final['mechanical-options'],
      'selected-stcc': this.selectedStcc,
      'user-filter': this.quoteRequestService.getActiveFilter(),
      'selected-cars': selectedCars,
      'selected-car-type': this.selectedCarType,
      'alternative-phone': null,
      reqeustStep: reqeustStep,
    };
    this.draftQuote(obj).subscribe(
      () => {},
      (error) => {}
    );
  }

  draftQuote(draftdata: any): Observable<any> {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    return this.http.post(this.config.submitdraftQuote, draftdata, {
      headers,
    });
  }

  setSelectedCarListDraft(attr: OptionModel[]) {
    this.selectedCarTypeAttributesSource$.next(attr);
  }
  getSelectedCarListDraft(): {} {
    const cardAttrList = this.selectedCarTypeAttributesSource$.value;
    return cardAttrList;
  }

  loadDraftQuote(draftdata: any) {
    const jsondata = draftdata ? draftdata[0].quote : null;
    if (jsondata) {
      const selectedCars = jsondata['selected-cars'];
      const { car_type, description_stcc } = jsondata['user-filter'];
      const stccNumber = description_stcc.split('-')[1]?.trim();
      const stcc_description = description_stcc.split('-')[0].trim();
      const selectedCarType = jsondata['selected-car-type'];
      const { model_id } = jsondata['selected-cars'][0];

      const obj = {
        StccObj: {
          stcc: stccNumber,
          stcc_description: stcc_description,
          description_stcc: description_stcc,
          car_types: [car_type],
          model_ids: [model_id],
        },
        CarType: selectedCarType,
      };
      sessionStorage.setItem(filterSelectionState, JSON.stringify(obj));
      this.router.navigate(['/search-inventory/search-cars']).then(() => {
        setTimeout(() => {
          const itemReqeustStep = jsondata['reqeustStep'];
          const detail: any = this.getSelectedCarListDraft();
          this.quoteRequestService.setSelectedCarList(selectedCars, detail);
          this.quoteRequestService.setQuoteRequest(jsondata);
          this.router.navigate(['/search-inventory/request-quote']);
          this.quoteRequestService.setNextStep(itemReqeustStep);
        }, 1200);
      });
    }
  }
}
